let skills = [
  {
    name: "HTML 5",
    logo: "/images/html.svg",
  },
  {
    name: "CSS 3",
    logo: "/images/css.svg",
  },
  {
    name: "JavaScript",
    logo: "/images/js.svg",
  },
  {
    name: "Git",
    logo: "/images/git.svg",
  },
  {
    name: "ReactJS",
    logo: "/images/react.svg",
  },
  {
    name: "Redux",
    logo: "/images/redux.svg",
  },
  {
    name: "NodeJS",
    logo: "/images/node.svg",
  },
  {
    name: "Tailwind CSS",
    logo: "/images/tailwind.svg",
  },
  {
    name: "SCSS/SASS",
    logo: "/images/sass.svg",
  },

  {
    name: "ExpressJS",
    logo: "/images/express.svg",
  },
  {
    name: "MongoDB",
    logo: "/images/mongo.svg",
  },
  {
    name: "PostgreSQL",
    logo: "/images/postgresql.svg",
  },
  {
    name: "Redis",
    logo: "/images/redis.svg",
  },

  {
    name: "EJS",
    logo: "/images/ejs.svg",
  },
];
export default skills;
